import { render, staticRenderFns } from "./DrinkArt.vue?vue&type=template&id=6229589b&"
import script from "./DrinkArt.vue?vue&type=script&lang=js&"
export * from "./DrinkArt.vue?vue&type=script&lang=js&"
import style0 from "./DrinkArt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports